import { useCallback, useEffect, useRef, useState } from "react";
import { CreditCard, Edit, Search, Server } from "react-feather";
import { MdDeleteForever } from "react-icons/md";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  deleteCreditDebitNote,
  filterCreditDebitDraft,
  filterCreditDebitNote,
  getCreditDebitDraftWithDetails,
  getCreditDebitHeaderWithDetails,
  getCreditDebitNoteEvInvDetails,
} from "../../api/finance/creditDebitNoteApi";
import { invoiceSearch } from "../../api/finance/invoiceSearchApi";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import CreateCreditDebitDraft from "../../components/finance/creditDebit/CreateCreditDebitDraft";
import CreateCreditDebitNote from "../../components/finance/creditDebit/CreateCreditDebitNote";
import InvoiceSearchComponent from "../../components/finance/InvoiceSearchComponent";
import Grid from "../../components/Grid";
import Button from "../../components/input/Button";
import CustomAlert from "../../components/input/CustomAlert";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import LoadingSpinner from "../../components/LoadingSpinner";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import MultiValueSelectRenderer from "../../components/renderer/MultiValueSelectRenderer";
import {
  ActiveCellStyle,
  CurrencyRenderer,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import Tab from "../../components/Tab";
import { FORMS, MODULES } from "../../const";
import { formatFromJsonDate } from "../../dateConfig";
import useUserCompany from "../../hooks/useUserCompany";

const noteCategory = {
  CREDIT: 1,
  DEBIT: 2,
};

const CreditDebitNote = () => {
  const searchGridRef = useRef();
  const [tab, setTab] = useState(1);
  const [jobsEv, setJobsEv] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchLoading, setIsFetchLoading] = useState(false);
  const [isDraftFetching, setIsDraftFetching] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [noteType, setNoteType] = useState(null); //credit or debit
  const [searchClickedEv, setSearchClickedEv] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDraftDrawerOpen, setIsDraftDrawerOpen] = useState(false);

  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [draftApprovalMode, setDraftApprovalMode] = useState(false);

  const [typeOptions, setTypeOptions] = useState([]);
  const [singleBulkOptions, setSingleBulkOptions] = useState([]);

  const [creditDebitCode, setCreditDebitCode] = useState("");
  const [singleBulk, setSingleBulk] = useState(null);
  const [type, setType] = useState(null);
  const [category, setCategory] = useState(null);
  const [eihCode, setEihCode] = useState("");
  const [customer, setCustomer] = useState(null);
  const [transporter, setTransporter] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [draftCode, setDraftCode] = useState("");
  const [draftSingleBulk, setDraftSingleBulk] = useState(null);
  const [draftType, setDraftType] = useState(null);
  const [draftCategory, setDraftCategory] = useState(null);
  const [draftEihCode, setDraftEihCode] = useState("");
  const [draftCustomer, setDraftCustomer] = useState(null);
  const [draftTransporter, setDraftTransporter] = useState(null);
  const [draftFromDate, setDraftFromDate] = useState("");
  const [draftToDate, setDraftToDate] = useState("");

  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [searchClicked2, setSearchClicked2] = useState(false);
  const [searchClicked3, setSearchClicked3] = useState(false);

  const [filteredCreditDebitList, setFilteredCreditDebitList] = useState([]);
  const [filteredDraftList, setFilteredDraftList] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const creditDebitGridRef = useRef(null);
  const draftGridRef = useRef(null);
  const [creditDebitDetails, setCreditDebitDetails] = useState({});
  const [activeAccordion3, handleAccordionClick3] = useState(true);
  const [activeAccordion2, handleAccordionClick2] = useState(true);
  const [activeAccordion1, handleAccordionClick1] = useState(true);
  const [cdCode, setCdCode] = useState("");
  const [draftCdCode, setDraftCdCode] = useState("");
  const [remark, setRemark] = useState("");
  const [dhdId, setDhdId] = useState(null);
  const [dcrId, setDcrId] = useState(null);
  const deleteRef = useRef(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [updateNeeded, setUpdateNeeded] = useState(false);
  const [cdActive, setCdActive] = useState(false);
  const cusRef = useRef();
  const transRef = useRef();
  const cusDraftRef = useRef();
  const transDraftRef = useRef();

  const userCompany = useUserCompany();
  const userCurrency = userCompany ? userCompany.comCurrency : null;
  const userCurrencyCode = userCompany ? userCompany.comCurrencyCode : null;

  const auth = useSelector((state) => state.user.permissions[MODULES.Finance]);
  const cdDraftPermission = auth[FORMS?.CREDIT_DEBIT.CD_DRAFT?.form];
  const cdNotePermission = auth[FORMS?.CREDIT_DEBIT.CD_NOTE?.form];
  const cdEvInvPermission = auth[FORMS?.CREDIT_DEBIT.CD_EV_INV?.form];
  const cdNoteDeletePermission = cdNotePermission?.FORM?.DELETE;

  useEffect(() => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setDraftFromDate(formattedWeekAgo);
    setDraftToDate(formattedToday);
  }, []);

  useEffect(() => {
    (async () => {
      const { rate_type_for: statusData, single_bulk: typeOpt } =
        await getBulkDropdownData([
          { key: "rate_type_for" },
          { key: "single_bulk" },
        ]);
      setTypeOptions(statusData);
      setSingleBulkOptions(typeOpt);
    })();
  }, []);

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setEditMode(false);
    setDraftApprovalMode(false);
    setRemark("");
    setNoteType(null);
    setCreditDebitDetails({});
    setCdActive(false);
    setTab(3);
  };

  const handleDraftDrawerClose = () => {
    setIsDraftDrawerOpen(false);
    setEditMode(false);
    setDraftApprovalMode(false);
    setRemark("");
    setNoteType(null);
    setDhdId(null);
    setCreditDebitDetails({});
    setTab(2);
  };

  const handleSelectionChange = useCallback(() => {
    const selectedData = searchGridRef.current.getSelectedData();
    console.log("selected data", selectedData);
    setSelectedRows(selectedData);
  }, []);

  const handleSearchEv = useCallback(async (data) => {
    handleAccordionClick1(false);
    setSearchClickedEv(true);
    setIsLoading(true);
    const result = await invoiceSearch(data);
    console.log("Invoice Search: ", result);
    const evInvList = [];
    for (let jobDetail of result) {
      const formater = jobDetail.currency
        ? Intl.NumberFormat("en-US", {
            style: "currency",
            currency: jobDetail.currency,
          })
        : null;
      evInvList.push({
        ...jobDetail,
        customer:
          jobDetail.eihsingle_bulk === 1
            ? jobDetail.customer
            : jobDetail.eihtype === 1
              ? jobDetail.customer
              : "N/A",
        transporter:
          jobDetail.eihsingle_bulk === 1
            ? jobDetail.transporter
            : jobDetail.eihtype === 2
              ? jobDetail.transporter
              : "N/A",
        createdFormatDate: formatFromJsonDate(jobDetail.createddate),
        formatter: formater,
      });
    }
    setJobsEv(evInvList);
    setSelectedRows([]);
    setIsLoading(false);
  }, []);

  const handleContinue = async () => {
    setIsFetchLoading(true);
    if (selectedRows?.length <= 0) return;
    const invoiceById = await getCreditDebitNoteEvInvDetails(
      selectedRows[0]?.eihid
    );
    setInvoiceDetails(invoiceById);
    setIsFetchLoading(false);
    setIsDraftDrawerOpen(true);
  };

  const getActionMenuOptions = () => {
    let actionMenuOptions = [];
    if (selectedRows?.length === 1) {
      actionMenuOptions = [
        {
          key: noteCategory.CREDIT,
          text: "Credit Note",
          value: noteCategory.CREDIT,
        },
        {
          key: noteCategory.DEBIT,
          text: "Debit Note",
          value: noteCategory.DEBIT,
        },
      ];
    }
    return actionMenuOptions;
  };

  const actionMenuHandler = (data) => {
    console.log("data", data);
    switch (data.value) {
      case noteCategory.CREDIT:
        if (selectedRows[0].eihactive !== 1) {
          toast.error("This Ev/INV is already deleted!", {
            autoClose: 3000,
            containerId: "Main",
          });
          return;
        }
        setNoteType(noteCategory.CREDIT);
        handleContinue();
        break;
      case noteCategory.DEBIT:
        if (selectedRows[0].eihactive !== 1) {
          toast.error("This Ev/INV is already deleted!", {
            autoClose: 3000,
            containerId: "Main",
          });
          return;
        }
        setNoteType(noteCategory.DEBIT);
        handleContinue();
        break;
      default:
        break;
    }
  };

  console.log("Note type", noteType);

  const handleSearchCreditDebit = useCallback(async () => {
    try {
      setSearchClicked3(true);
      handleAccordionClick3(false);
      setIsDataLoading(true);
      const searchRes = await filterCreditDebitNote({
        code: creditDebitCode,
        singleBulk: singleBulk,
        type: type,
        category: category,
        eihCode: eihCode,
        customer: customer,
        transporter: transporter,
        fromDate: fromDate,
        toDate: toDate,
      });

      let searchList = [];
      for (let cdNote of searchRes) {
        searchList.push({
          ...cdNote,
          dcrCustomerValue: cdNote.dcrCustomerValue
            ? cdNote.dcrCustomerValue
            : "N/A",
          dcrTransporterValue: cdNote.dcrTransporterValue
            ? cdNote.dcrTransporterValue
            : "N/A",
          dcrInvCustomerValue: cdNote.dcrInvCustomerValue
            ? cdNote.dcrInvCustomerValue
            : "N/A",
          dcrBillingCustomerValue: cdNote.dcrBillingCustomerValue
            ? cdNote.dcrBillingCustomerValue
            : "N/A",
          dcrIntegrationStatus: cdNote.dcrIntegrationStatus
            ? cdNote.dcrIntegrationStatus
            : "N/A",
          createdDate: cdNote.createdDate
            ? cdNote.createdDate.split("T")[0]
            : "N/A",
          createdBy: cdNote.createdBy ? cdNote.createdBy : "N/A",
          lastModifiedBy: cdNote.lastModifiedBy ? cdNote.lastModifiedBy : "N/A",
          lastModifiedDate: cdNote.lastModifiedDate
            ? cdNote.lastModifiedDate.split("T")[0]
            : "N/A",
        });
      }
      setFilteredCreditDebitList(searchList);
      setIsDataLoading(false);
    } catch (e) {
      console.error(e);
    }
  }, [
    creditDebitCode,
    singleBulk,
    type,
    category,
    eihCode,
    customer,
    transporter,
    fromDate,
    toDate,
  ]);

  const handleResetCreditDebit = useCallback(() => {
    handleAccordionClick3(true);
    setCreditDebitCode("");
    setSingleBulk(null);
    setType(null);
    setCategory(null);
    setEihCode("");
    setCustomer(null);
    setTransporter(null);
    cusRef.current.reset();
    transRef.current.reset();
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setSearchClicked3(false);
  }, []);

  const handleSearchCreditDebitDraft = useCallback(async () => {
    try {
      setSearchClicked2(true);
      handleAccordionClick2(false);
      setIsDataLoading(true);
      const searchRes = await filterCreditDebitDraft({
        code: draftCode,
        singleBulk: draftSingleBulk,
        type: draftType,
        category: draftCategory,
        eihCode: draftEihCode,
        customer: draftCustomer,
        transporter: draftTransporter,
        fromDate: draftFromDate,
        toDate: draftToDate,
      });

      let searchList = [];
      for (let dNote of searchRes) {
        searchList.push({
          ...dNote,
          dhdCustomerValue: dNote.dhdCustomerValue
            ? dNote.dhdCustomerValue
            : "N/A",
          dhdTransporterValue: dNote.dhdTransporterValue
            ? dNote.dhdTransporterValue
            : "N/A",
          dhdInvCustomerValue: dNote.dhdInvCustomerValue
            ? dNote.dhdInvCustomerValue
            : "N/A",
          dhdBillingCustomerValue: dNote.dhdBillingCustomerValue
            ? dNote.dhdBillingCustomerValue
            : "N/A",
        });
      }
      setFilteredDraftList(searchList);
      setIsDataLoading(false);
    } catch (e) {
      console.error(e);
    }
  }, [
    draftCode,
    draftSingleBulk,
    draftType,
    draftCategory,
    draftEihCode,
    draftCustomer,
    draftTransporter,
    draftFromDate,
    draftToDate,
  ]);

  useEffect(() => {
    if (updateNeeded) {
      handleSearchCreditDebitDraft();
      setUpdateNeeded(false);
    }
  }, [updateNeeded, handleSearchCreditDebitDraft]);

  const handleResetCreditDebitDraft = useCallback(() => {
    handleAccordionClick2(true);
    setDraftCode("");
    setDraftSingleBulk(null);
    setDraftType(null);
    setDraftCategory(null);
    setDraftEihCode("");
    setDraftCustomer(null);
    setDraftTransporter(null);
    cusDraftRef.current.reset();
    transDraftRef.current.reset();
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setDraftFromDate(formattedWeekAgo);
    setDraftToDate(formattedToday);
    setSearchClicked2(false);
  }, []);

  useEffect(() => {
    if (updateNeeded) {
      handleSearchCreditDebit();
      setUpdateNeeded(false);
    }
  }, [updateNeeded, handleSearchCreditDebit]);

  const handleDelete = async (dcrId) => {
    setIsDeleting(true);
    const deletedNote = await deleteCreditDebitNote(dcrId);
    if (deletedNote?.status === 200) {
      toast.success(`${deletedNote.data} deleted successfully`, {
        autoClose: 5000,
        containerId: "Main",
      });
      setDcrId(null);
      setUpdateNeeded(true);
    } else {
      toast.error("Error occurred in deleting", {
        autoClose: 5000,
        containerId: "Main",
      });
    }
    setIsDeleting(false);
  };

  const [selectedCDNoteList, setSelectedCDNoteList] = useState([]);
  const [selectedCDDraftList, setSelectedCDDraftList] = useState([]);
  const handleSelectionChanged = useCallback(() => {
    if (creditDebitGridRef.current) {
      const selectedData = creditDebitGridRef.current.getSelectedData();
      setSelectedCDNoteList(selectedData);
    }
  }, []);

  const handleDraftSelectionChanged = useCallback(() => {
    if (draftGridRef.current) {
      const selectedData = draftGridRef.current.getSelectedData();
      setSelectedCDDraftList(selectedData);
    }
  }, []);

  console.log("selectedCDNoteList", selectedCDNoteList);
  return (
    <>
      {isFetchLoading && (
        <div className="blur-overlay">
          <LoadingSpinner
            message={
              !editMode
                ? `Fetching ${selectedRows[0].eihcode} Details...`
                : `Fetching ${cdCode} Details...`
            }
          />
        </div>
      )}
      {isDraftFetching && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Fetching ${draftCdCode} Details...`} />
        </div>
      )}

      <div className="ui tabular menu top attached">
        {cdEvInvPermission ? (
          <Tab
            Icon={Server}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Search EV/INV"
          />
        ) : (
          ""
        )}
        {cdDraftPermission ? (
          <Tab
            Icon={Edit}
            onClick={() => {
              setTab(2);
            }}
            active={tab === 2}
            label="Search Draft"
          />
        ) : (
          ""
        )}
        {cdNotePermission ? (
          <Tab
            Icon={CreditCard}
            onClick={() => {
              setTab(3);
            }}
            active={tab === 3}
            label="Search Credit/Debit Note"
          />
        ) : (
          ""
        )}
      </div>
      {cdEvInvPermission && (
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 1 ? "block" : "none" }}
        >
          <div
            class="ui styled accordion"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
              className={`title ${activeAccordion1 ? "active" : ""}`}
              onClick={() => handleAccordionClick1(!activeAccordion1)}
            >
              <div>
                Click here to expand search
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div className={`content ${activeAccordion1 ? "active" : ""}`}>
              <InvoiceSearchComponent
                searchResHandler={handleSearchEv}
                resetHandler={() => {
                  setJobsEv([]);
                  setSearchClickedEv(false);
                }}
                isHide={false}
              />
            </div>
          </div>
          {searchClickedEv && (
            <>
              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <Grid
                  ref={searchGridRef}
                  wrapText={false}
                  multiRowSelection={false}
                  onSelectionChanged={handleSelectionChange}
                  isLoading={isLoading}
                  searchable={false}
                  showActionMenu={
                    selectedRows?.length === 1 &&
                    jobsEv?.length > 0 &&
                    selectedRows[0].eihactive === 1
                  }
                  actionMenuOptions={getActionMenuOptions()}
                  handleActionMenuChange={actionMenuHandler}
                  config={[
                    {
                      headerName: "EV/INV Code",
                      field: "eihcode",
                      headerCheckboxSelection: true,
                      checkboxSelection: true,
                      pinned: "left",
                      minWidth: 150,
                      width: 150,
                      filter: true,
                    },
                    {
                      headerName: "Single Or Bulk",
                      field: "eihsingle_bulk_desc",
                    },
                    { headerName: "Type name", field: "eihtype_name" },
                    { headerName: "EV Or INV", field: "ceihtype" },
                    {
                      headerName: "Job Code",
                      field: "eihjob_no",
                      cellRenderer: MultiValueSelectRenderer,
                    },
                    {
                      headerName: "Amount",
                      field: "eihwith_tax",
                      cellRenderer: CurrencyRenderer,
                      cellRendererParams: (params) => ({
                        formatter: params.data.formatter,
                      }),
                    },
                    {
                      headerName: "Amount Without Tax",
                      field: "eihwithout_tax",
                      cellRenderer: CurrencyRenderer,
                      cellRendererParams: (params) => ({
                        formatter: params.data.formatter,
                      }),
                    },
                    {
                      headerName: "Customer",
                      field: "customer",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Inv Customer",
                      field: "invCustomer",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Transporter",
                      field: "transporter",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Status",
                      field: "eihstatus_name",
                      cellRenderer: StatusCellStyle,
                    },
                    {
                      headerName: "Active",
                      field: "eihactive_namet",
                      cellRenderer: ActiveCellStyle,
                      pinned: "right",
                      width: "120",
                      minWidth: "120",
                    },
                    {
                      headerName: "Created Date",
                      field: "createdFormatDate",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    { headerName: "Created By", field: "createdby" },
                  ]}
                  content={jobsEv}
                />
              )}
            </>
          )}
        </div>
      )}

      {cdDraftPermission && (
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 2 ? "block" : "none" }}
        >
          <div
            class="ui styled accordion"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
              className={`title ${activeAccordion2 ? "active" : ""}`}
              onClick={() => handleAccordionClick2(!activeAccordion2)}
            >
              <div>
                Click here to expand search
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div className={`content ${activeAccordion2 ? "active" : ""}`}>
              <div className="ui form">
                <div className="three fields">
                  <Input
                    type={"text"}
                    label={"Draft Code"}
                    value={draftCode}
                    onChange={(e) => setDraftCode(e.target.value)}
                    placeholder={"EX: DHD-0000001"}
                  />
                  <Input
                    type={"date"}
                    label={"From Date"}
                    value={draftFromDate}
                    onChange={(e) => setDraftFromDate(e.target.value)}
                  />
                  <Input
                    type={"date"}
                    label={"To Date"}
                    value={draftToDate}
                    onChange={(e) => setDraftToDate(e.target.value)}
                  />
                </div>
                <div className="three fields">
                  <Dropdown
                    label={"Single/Bulk"}
                    options={singleBulkOptions}
                    value={draftSingleBulk}
                    onChange={(e, data) => setDraftSingleBulk(data.value)}
                    placeholder={"Single/Bulk"}
                  />
                  <Dropdown
                    label={"EV/INV Type"}
                    options={typeOptions}
                    value={draftType}
                    onChange={(e, data) => setDraftType(data.value)}
                    placeholder={"Type"}
                  />
                  <Dropdown
                    label={"Category"}
                    options={[
                      {
                        key: noteCategory.CREDIT,
                        text: "Credit",
                        value: noteCategory.CREDIT,
                      },
                      {
                        key: noteCategory.DEBIT,
                        text: "Debit",
                        value: noteCategory.DEBIT,
                      },
                    ]}
                    value={draftCategory}
                    onChange={(e, data) => setDraftCategory(data.value)}
                    placeholder={"Category"}
                  />
                </div>
                <div className="three fields">
                  <Input
                    type={"text"}
                    label={"EV/INV Code"}
                    value={draftEihCode}
                    onChange={(e) => setDraftEihCode(e.target.value)}
                    placeholder={"EX: EIH-0000001"}
                  />
                  <SearchDropdown
                    key={1}
                    ref={cusDraftRef}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    onResultSelect={(data) => {
                      setDraftCustomer(data);
                    }}
                    clearable={true}
                    onClear={() => {
                      setDraftCustomer("");
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    label="Customer"
                  />
                  <SearchDropdown
                    key={1}
                    ref={transDraftRef}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    onResultSelect={(data) => {
                      setDraftTransporter(data);
                    }}
                    clearable={true}
                    onClear={() => {
                      setDraftTransporter("");
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={handleSearchCreditDebitDraft}
                    />
                    <Button
                      template="searchReset"
                      onClick={handleResetCreditDebitDraft}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {searchClicked2 && (
            <>
              {isDataLoading ? (
                <LoadingSpinner />
              ) : (
                <Grid
                  ref={draftGridRef}
                  wrapText={false}
                  heading={
                    filteredDraftList?.length > 0
                      ? "Filtered Credit/Debit Drafts"
                      : ""
                  }
                  isLoading={isDataLoading}
                  searchable={true}
                  multiRowSelection={true}
                  showDownloadButton={
                    selectedCDDraftList && selectedCDDraftList?.length > 0
                  }
                  onSelectionChanged={handleDraftSelectionChanged}
                  downloadParam={JSON.stringify(selectedCDDraftList)}
                  downloadAction="Credit Debit Draft Excel Download"
                  reportName={"Credit/Debit Drafts.csv"}
                  config={[
                    {
                      headerName: "Draft Code",
                      field: "dhdCode",
                      cellRenderer: ResizableScrollingTextRenderer,
                      pinned: "left",
                      minWidth: 150,
                      width: 150,
                      filter: true,
                      headerCheckboxSelection: true,
                      checkboxSelection: true,
                    },
                    {
                      headerName: "Single Or Bulk",
                      field: "dhdSingleBulkValue",
                    },
                    { headerName: "EV/INV", field: "dhdTypeValue" },
                    {
                      headerName: "Credit/Debit",
                      field: "dhdCategoryValue",
                    },
                    {
                      headerName: "EV/INV Code",
                      field: "dhdEvinvCode",
                      cellRenderer: MultiValueSelectRenderer,
                    },
                    {
                      headerName: "Customer",
                      field: "dhdCustomerValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Transporter",
                      field: "dhdTransporterValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Billing Customer",
                      field: "dhdBillingCustomerValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Inv Customer",
                      field: "dhdInvCustomerValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Amount",
                      field: "totAmount",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Status",
                      field: "dhdStatusValue",
                      cellRenderer: StatusCellStyle,
                      pinned: "right",
                      minWidth: 100,
                      width: 100,
                    },
                    {
                      headerName: "Active",
                      field: "dhdActiveValue",
                      cellRenderer: ActiveCellStyle,
                      pinned: "right",
                      minWidth: 100,
                      width: 100,
                    },
                  ]}
                  content={filteredDraftList}
                  onCellDoubleClicked={async (props) => {
                    setIsDraftFetching(true);
                    setEditMode(false);
                    setDraftApprovalMode(true);
                    setDhdId(props.data.dhdId);
                    setDraftCdCode(props.data.dhdCode);
                    const invoiceById = await getCreditDebitNoteEvInvDetails(
                      props.data.dhdEvinvId
                    );
                    setInvoiceDetails(invoiceById);

                    const res = await getCreditDebitDraftWithDetails(
                      props.data.dhdId
                    );
                    console.log("creditDebitDetails: ", res);
                    setCreditDebitDetails(res);

                    setNoteType(
                      props.data.dhdCategory === noteCategory.CREDIT
                        ? noteCategory.CREDIT
                        : noteCategory.DEBIT
                    );
                    setIsDraftDrawerOpen(true);
                    setIsDraftFetching(false);
                  }}
                />
              )}
            </>
          )}
        </div>
      )}

      {cdNotePermission && (
        <div
          className="ui bottom attached active tab segment"
          style={{ display: tab === 3 ? "block" : "none" }}
        >
          <div
            class="ui styled accordion"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
              className={`title ${activeAccordion3 ? "active" : ""}`}
              onClick={() => handleAccordionClick3(!activeAccordion3)}
            >
              <div>
                Click here to expand search
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i class="dropdown icon"></i>
              </div>
            </div>
            <div className={`content ${activeAccordion3 ? "active" : ""}`}>
              <div className="ui form">
                <div className="three fields">
                  <Input
                    type={"text"}
                    label={"Credit/Debit Code"}
                    value={creditDebitCode}
                    onChange={(e) => setCreditDebitCode(e.target.value)}
                    placeholder={"EX: DCR-0000001"}
                  />
                  <Input
                    type={"date"}
                    label={"From Date"}
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <Input
                    type={"date"}
                    label={"To Date"}
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
                <div className="three fields">
                  <Dropdown
                    label={"Single/Bulk"}
                    options={singleBulkOptions}
                    value={singleBulk}
                    onChange={(e, data) => setSingleBulk(data.value)}
                    placeholder={"Select Single/Bulk"}
                  />
                  <Dropdown
                    label={"EV/INV Type"}
                    options={typeOptions}
                    value={type}
                    onChange={(e, data) => setType(data.value)}
                    placeholder={"Select Type"}
                  />
                  <Dropdown
                    label={"Category"}
                    options={[
                      {
                        key: noteCategory.CREDIT,
                        text: "Credit",
                        value: noteCategory.CREDIT,
                      },
                      {
                        key: noteCategory.DEBIT,
                        text: "Debit",
                        value: noteCategory.DEBIT,
                      },
                    ]}
                    value={category}
                    onChange={(e, data) => setCategory(data.value)}
                    placeholder={"Select Category"}
                  />
                </div>
                <div className="three fields">
                  <Input
                    type={"text"}
                    label={"EV/INV Code"}
                    value={eihCode}
                    onChange={(e) => setEihCode(e.target.value)}
                    placeholder={"EX: EIH-0000001"}
                  />
                  <SearchDropdown
                    key={1}
                    ref={cusRef}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    onResultSelect={(data) => {
                      setCustomer(data);
                    }}
                    clearable={true}
                    onClear={() => {
                      setCustomer("");
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    label="Customer"
                  />
                  <SearchDropdown
                    key={1}
                    ref={transRef}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    onResultSelect={(data) => {
                      setTransporter(data);
                    }}
                    clearable={true}
                    onClear={() => {
                      setTransporter("");
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={handleSearchCreditDebit}
                    />
                    <Button
                      template="searchReset"
                      onClick={handleResetCreditDebit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {searchClicked3 && (
            <>
              {isDataLoading ? (
                <LoadingSpinner />
              ) : (
                <Grid
                  ref={creditDebitGridRef}
                  wrapText={false}
                  heading={
                    filteredCreditDebitList?.length > 0
                      ? "Filtered Credit/Debit Notes"
                      : ""
                  }
                  isLoading={isDataLoading}
                  searchable={true}
                  multiRowSelection={true}
                  showDownloadButton={
                    selectedCDNoteList && selectedCDNoteList?.length > 0
                  }
                  onSelectionChanged={handleSelectionChanged}
                  downloadParam={JSON.stringify(selectedCDNoteList)}
                  downloadAction="Credit Debit Note Excel Download"
                  reportName={"Credit/Debit Notes.csv"}
                  config={[
                    {
                      headerName: "Credit/Debit Code",
                      field: "dcrCode",
                      cellRenderer: ResizableScrollingTextRenderer,
                      pinned: "left",
                      minWidth: 150,
                      width: 150,
                      filter: true,
                      headerCheckboxSelection: true,
                      checkboxSelection: true,
                    },
                    {
                      headerName: "Single Or Bulk",
                      field: "dcrSingleBulkValue",
                    },
                    { headerName: "EV/INV", field: "dcrTypeValue" },
                    {
                      headerName: "Credit/Debit",
                      field: "dcrCategoryValue",
                    },
                    {
                      headerName: "EV/INV Code",
                      field: "dcrEvinvCode",
                      cellRenderer: MultiValueSelectRenderer,
                    },
                    {
                      headerName: "Customer",
                      field: "dcrCustomerValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Transporter",
                      field: "dcrTransporterValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Billing Customer",
                      field: "dcrBillingCustomerValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Inv Customer",
                      field: "dcrInvCustomerValue",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Amount",
                      field: "totAmount",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Integration Status",
                      field: "dcrIntegrationStatus",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Created By",
                      field: "createdBy",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Created Date",
                      field: "createdDate",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Last Modified By",
                      field: "lastModifiedBy",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Last Modified Date",
                      field: "lastModifiedDate",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Status",
                      field: "dcrStatusValue",
                      cellRenderer: StatusCellStyle,
                      minWidth: 100,
                      width: 100,
                      pinned: "right",
                    },
                    {
                      headerName: "Active",
                      field: "dcrActiveValue",
                      cellRenderer: ActiveCellStyle,
                      minWidth: 100,
                      width: 100,
                      pinned: "right",
                    },
                    {
                      headerName: "Delete",
                      cellRenderer: ButtonRenderer,
                      pinned: "right",
                      width: "90",
                      minWidth: "90",
                      cellRendererParams: (params) => {
                        console.log(params);
                        return {
                          clickHandler: async () => {
                            setCdCode(params.data.dcrCode);
                            setDcrId(params.data.dcrId);
                            deleteRef.current?.openAlert();
                          },
                          label: "Delete",
                          Icon: MdDeleteForever,
                          className: `ui ${params.data.dcrActive === 2 ? "grey" : "red"} button`,
                          disabled:
                            params.data.dcrActive === 2 ||
                            !cdNoteDeletePermission,
                        };
                      },
                    },
                  ]}
                  content={filteredCreditDebitList}
                  onCellDoubleClicked={async (props) => {
                    setIsFetchLoading(true);
                    setEditMode(true);
                    setDraftApprovalMode(false);
                    setCdCode(props.data.dcrCode);

                    const invoiceById = await getCreditDebitNoteEvInvDetails(
                      props.data.dcrEvinvId
                    );
                    setInvoiceDetails(invoiceById);

                    const res = await getCreditDebitHeaderWithDetails(
                      props.data.dcrId
                    );
                    console.log("creditDebitDetails: ", res);
                    setCreditDebitDetails(res);
                    setCdActive(res.dcrActive === 1 ? true : false);
                    setNoteType(
                      props.data.dcrCategory === noteCategory.CREDIT
                        ? noteCategory.CREDIT
                        : noteCategory.DEBIT
                    );
                    setIsDrawerOpen(true);
                    setIsFetchLoading(false);
                  }}
                />
              )}
            </>
          )}
        </div>
      )}

      {isDeleting && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Deleting ${cdCode}...`} />
        </div>
      )}
      <CustomAlert
        ref={deleteRef}
        message={`Are you sure you want to delete ${cdCode}?`}
        onAccept={() => {
          handleDelete(dcrId);
        }}
      />
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          <div className="drawer-header">
            <div style={{ padding: "10px 0 10px 0" }}>
              <h3>
                {!editMode
                  ? `${noteType === noteCategory.CREDIT ? "Create Credit Note" : "Create Debit Note"}`
                  : `View ${cdCode}`}
              </h3>
            </div>
          </div>
        }
        body={
          <CreateCreditDebitNote
            invoiceDetails={invoiceDetails}
            editMode={editMode}
            draftApprovalMode={draftApprovalMode}
            noteType={noteType}
            creditDebitDetails={creditDebitDetails}
            handleDrawerClose={handleDrawerClose}
            remark={remark}
            setRemark={setRemark}
            cdActive={cdActive}
            setUpdateNeeded={setUpdateNeeded}
          />
        }
        style={{ width: "90vw", boxShadow: "none" }}
      />
      <SideDrawer
        open={isDraftDrawerOpen}
        handleDrawerClose={handleDraftDrawerClose}
        head={
          <div className="drawer-header">
            <div style={{ padding: "10px 0 10px 0" }}>
              <h3>
                {draftApprovalMode
                  ? `Approve ${draftCdCode}`
                  : "Create Credit/Debit Draft"}
              </h3>
            </div>
          </div>
        }
        body={
          <CreateCreditDebitDraft
            invoiceDetails={invoiceDetails}
            editMode={editMode}
            draftApprovalMode={draftApprovalMode}
            noteType={noteType}
            creditDebitDetails={creditDebitDetails}
            handleDraftDrawerClose={handleDraftDrawerClose}
            remark={remark}
            setRemark={setRemark}
            dhdId={dhdId}
            setUpdateNeeded={setUpdateNeeded}
          />
        }
        style={{ width: "90vw", boxShadow: "none" }}
      />
    </>
  );
};

export default CreditDebitNote;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
